module.exports = __webpack_public_path__ + "static/media/photography-and-video-shoots.5c574fc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/photography-and-video-shoots.svg
// module id = 323
// module chunks = 0